// /profile/edit (004 FR-004, FR-005).
import { EditDetailsScreen } from "@/profile/EditDetailsScreen";

export default function EditDetails() {
  return <EditDetailsScreen />;
}
